export const strapiUrl = process.env.NODE_ENV === 'production' ? 'https://toftejendomme-admin.onrender.com' : 'https://toftejendomme-admin.onrender.com'